.lane {
  margin-bottom: 40px;
}

.head,
.toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.toggle {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: var(--ps-text-secondary);
}

.title {
  font-size: var(--ps-text-lg);
  font-weight: 700;
  margin: 0;
}

/* Collapsible lanes ("Other") get a quieter heading. */
.toggle .title {
  font-size: 16px;
  font-weight: 600;
  color: var(--ps-text-secondary);
}

.count {
  font-size: 12px;
  color: var(--ps-text-muted);
  background: var(--ps-bg-elevated);
  padding: 2px 10px;
  border-radius: var(--ps-radius-pill);
}

.sub {
  font-size: 13px;
  color: var(--ps-text-muted);
  margin: 0 0 16px;
}

.chevron {
  transition: transform 0.2s;
}

.chevron[data-open='true'] {
  transform: rotate(180deg);
}
